"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckoutNoResults = void 0;
const next_i18next_1 = require("next-i18next");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_buttons_1 = require("@hotelplan/components.common.buttons");
const CardWrapWithError = styled_components_1.default.div(({ theme }) => theme.modals.notificationCardWrapWithError, ({ theme }) => theme.checkout.checkoutNoResults);
const CheckoutResultsWrapper = styled_components_1.default.div(({ theme }) => theme.checkout.checkoutResultsWrapper);
const CheckoutResultsFlex = styled_components_1.default.div(({ theme }) => theme.checkout.checkoutResultsFlex);
const CheckoutNoResults = ({ onCancel, onRequestAssistance }) => {
    const [t] = (0, next_i18next_1.useTranslation)('checkout');
    return (react_1.default.createElement(CardWrapWithError, null,
        react_1.default.createElement("div", { className: "notification-content" },
            react_1.default.createElement("h3", { className: "title" }, t('checkout:offerNotAvailable.title')),
            onCancel && react_1.default.createElement("p", null, t('checkout:offerNotAvailable.text')),
            onRequestAssistance && (react_1.default.createElement("p", null, t('checkout:offerNotAvailable.assistance.text')))),
        onCancel && (react_1.default.createElement(components_common_buttons_1.Button, { onClick: onCancel }, t('checkout:offerNotAvailable.startNewSearch'))),
        onRequestAssistance && (react_1.default.createElement(components_common_buttons_1.Button, { onClick: onRequestAssistance }, t('checkout:offerNotAvailable.requestAssistance')))));
};
exports.CheckoutNoResults = CheckoutNoResults;
const CheckoutResults = ({ priceChanged, flightChanged, price, onCancel, onAccept, flightChangedComponent, }) => {
    const [t] = (0, next_i18next_1.useTranslation)(['common', 'checkout']);
    const bothChanged = priceChanged && flightChanged;
    const priceChangedTitle = priceChanged
        ? t('checkout:priceChanged.title')
        : null;
    const flightChangedTitle = flightChanged
        ? t('checkout:flightChanged.title')
        : null;
    const title = bothChanged
        ? t('checkout:priceAndFlightChanged.title')
        : priceChangedTitle || flightChangedTitle;
    return (react_1.default.createElement(CheckoutResultsWrapper, null,
        react_1.default.createElement("h3", { className: "title" }, title),
        flightChanged && (react_1.default.createElement("div", { className: "flight-changed-text" },
            react_1.default.createElement("p", null, t('checkout:flightChanged.flightNotAvailable')),
            react_1.default.createElement("p", null, t('checkout:flightChanged.flightAlternativesText')))),
        flightChanged ? flightChangedComponent : null,
        priceChanged && price ? (react_1.default.createElement("p", { className: "price-changed-text" }, t('checkout:priceChanged.text.count', {
            count: parseInt(price, 10),
        }))) : null,
        react_1.default.createElement("p", { className: "continue-booking-title" }, t('checkout:continueToBooking')),
        react_1.default.createElement(CheckoutResultsFlex, null,
            react_1.default.createElement(components_common_buttons_1.Button, { className: "link-btn", variant: "linkBtn", onClick: onCancel }, t('common:cancel')),
            react_1.default.createElement(components_common_buttons_1.Button, { onClick: onAccept }, t('common:takeOver')))));
};
exports.default = CheckoutResults;
//# sourceMappingURL=CheckoutResults.js.map